"use client";
import * as React from "react";
const SvgLiveTvRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m6.91 10.57 2.9-1.61a.7.7 0 0 0 0-1.23L6.9 6.11c-.49-.26-1.1.08-1.1.62v3.22c0 .54.61.89 1.1.62Zm7.64-7.88H9.03L11.16.6a.34.34 0 0 0 0-.5.37.37 0 0 0-.51 0L8 2.68 5.35.11a.37.37 0 0 0-.51 0 .34.34 0 0 0 0 .5l2.13 2.08h-5.5C.66 2.69 0 3.32 0 4.1v8.49C0 13.35.66 14 1.46 14h13.09c.8 0 1.45-.64 1.45-1.41V4.1c0-.78-.65-1.41-1.45-1.41m-.73 9.9H2.18a.7.7 0 0 1-.72-.71V4.8a.7.7 0 0 1 .72-.7h11.64c.4 0 .73.3.73.7v7.07a.7.7 0 0 1-.73.7" }));
export {
  SvgLiveTvRound as default
};
